import PropTypes from 'prop-types';
import { Icon } from '@iconify/react';
import { Card } from '@core/components/ui';

/**
 * ResponseSuccessState Component
 *
 * Success state displayed after successfully submitting a response.
 * Shows success icon and customizable message.
 *
 * @param {Object} props
 * @param {string} props.title - Success message title
 * @param {string} props.message - Success message body
 * @param {string} [props.candidateName] - Optional candidate name to personalize message
 */
export function ResponseSuccessState({ title, message, candidateName }) {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-zinc-50 p-4">
      <Card className="max-w-md w-full">
        <div className="text-center">
          <Icon icon="lucide:check-circle" className="size-16 text-success mx-auto mb-4" />
          <h2 className="text-xl font-semibold text-default mb-2">{title}</h2>
          <p className="text-subtle mb-2">
            {candidateName && `Hola ${candidateName}, `}
            {message}
          </p>
        </div>
      </Card>
    </div>
  );
}

ResponseSuccessState.propTypes = {
  title: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  candidateName: PropTypes.string,
};
